import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Props {
  analytic?: Analytic<number | string | null>
}

const AnalyticTextResult = ({ analytic }: Props): JSX.Element | null => {
  if (!analytic || analytic.error) {
    return null
  }

  return (
    <Text.Normal weight="normal" color="grey1000">
      {analytic?.results?.[0]?.value}
    </Text.Normal>
  )
}

export default observer(AnalyticTextResult)
